'use client'

import { Listbox, ListboxLabel, ListboxOption } from '@algoacademy/design-system/web/forms/Listbox'
import { type ReactNode, useState } from 'react'

export type CompensationFormTab = {
  title: string
  content: ReactNode
}

type CompensationFormsProps = {
  forms: CompensationFormTab[]
}

export function CompensationForms({ forms }: CompensationFormsProps) {
  const [activeTitle, setActiveTitle] = useState(forms[0]?.title ?? '')
  const activeForm = forms.find(form => form.title === activeTitle) ?? forms[0]

  if (!activeForm) {
    return null
  }

  return (
    <div className='overflow-hidden rounded-2xl border border-borderPrimary bg-backgroundPrimary'>
      <div className='flex flex-col gap-3 border-borderPrimary border-b bg-blue-50/70 px-5 py-4 sm:flex-row sm:items-center sm:justify-between'>
        <div className='space-y-0.5'>
          <p className='font-semibold text-slate-800 text-sm'>Forma współpracy</p>
          <p className='text-slate-500 text-xs'>Wybierz model, który Cię interesuje</p>
        </div>
        <Listbox
          value={activeTitle}
          onChange={setActiveTitle}
          aria-label='Forma współpracy'
          className='w-full sm:w-64'
        >
          {forms.map(form => (
            <ListboxOption key={form.title} value={form.title}>
              <ListboxLabel>{form.title}</ListboxLabel>
            </ListboxOption>
          ))}
        </Listbox>
      </div>
      <div className='space-y-2 p-5'>{activeForm.content}</div>
    </div>
  )
}
